import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import _ from 'lodash'
import { updateGroup, deleteGroup } from '../../../../../api'
import { AuthContext } from '../../../../../auth-context'
import { Input } from '@material-ui/core'
import moment from 'moment'
import Modal from '../../../../../components/modal'
import EditIcon from '@material-ui/icons/Edit'
import SaveIcon from '@material-ui/icons/Save'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import SearchIcon from '@material-ui/icons/Search'
import { DashboardContext } from '../../../dashboard-context'
import { Row, Action } from '../../../../../components/action-button'

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding: 0px 16px 64px 16px;
`

const TableTitle = styled.h2`
  padding-bottom: 16px;
  margin: 0 auto;
  color: #555;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
`

const TableContainer = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  height: 700px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
`

const Table = styled.table`
  background: #FFF;
  border-spacing: 0px;
  width: 100%;
`

const TableHead = styled.thead`
  color: #FFF;
`

const TableBody = styled.tbody`
`

const TableHeadRow = styled.tr`
`

const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${props => props.theme.font.primary};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${props => (props.bigWidth) ? '160px' : '100px' };
  padding: 8px;
  position: sticky;
  top: 0;
  z-index: 30;
`

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${props => props.number ? props.theme.font.primary : props.theme.font.secondary};
  padding: 4px;
  text-align: center;
`

const ButtonCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-size: .875rem;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const RemoveText = styled.h4`
  color: #555;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
`

const GroupsTable = (props) => {
  const { openSnackbar } = useContext(DashboardContext);
  const { user, updateUser } = useContext(AuthContext);
  const [editing, updateEditing] = useState(false)
  const [showDeleteModal, updateShowDeleteModal] = useState(false)
  const [groupID, updateGroupID] = useState(null)
  const [groupName, updateGroupName] = useState('')
  const [loading, updateLoading] = useState(false)

  const handleEditIcon = (group) => {
    if (editing) {
      updateEditing(false)
    } else {
      updateGroupID(group.id)
      updateGroupName(group.name)
      updateEditing(true)
    }
  }

  const handleSave = () => {
    if(groupName === '') {
      openSnackbar('Please enter a new name for the group.', true)
    } else {
      const lowerName = groupName.toLowerCase()
      let duplicate = false
      for(let i = 0; i < user.groups.length; ++i) {
        if (user.groups[i].id !== groupID && user.groups[i].name.toLowerCase() === lowerName) {
          duplicate = true
          break
        }
      }
      if(duplicate) {
        openSnackbar('Another group already has that name.', true)
      } else {
        updateGroup(user.id, groupID, groupName).then((res) => {
          let newUser = Object.assign({}, user)
          newUser.groups = user.groups.map((entry, index) => entry.id === groupID ? Object.assign({}, entry, {name: groupName}) : entry)
          updateUser(newUser)
          updateEditing(false)
          openSnackbar('Group successfully updated.', false)
        }).catch((err) => {
          console.log(err) 
          openSnackbar('There was a problem updating this group.', true)
        })
      }
    }
  }

  const handleDeleteIcon = (group) => {
    updateEditing(false)
    updateGroupID(group.id)
    updateGroupName(group.name)
    updateShowDeleteModal(true)
  }

  const handleDelete = () => {
    updateLoading(true)

    deleteGroup(user.id, groupID).then((res) => {
      let newUser = Object.assign({}, user)
      _.remove(newUser.groups, (member) => {
        return member.id === groupID
      })

      setTimeout(() => {
        updateLoading(false)
        updateUser(newUser)
        updateShowDeleteModal(false)
        openSnackbar('Group successfully deleted', false)
      }, 700);
    }).catch((err) => {
      updateLoading(false)
      updateShowDeleteModal(false)
      openSnackbar('Error deleting group', true)
    })
  }

  return (
    <Container>
      <TableTitle>Found {user.groups.length} group(s)</TableTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableHeadRow>
              <HeadCell>Name</HeadCell>
              <HeadCell>Clients</HeadCell>
              <HeadCell>Created Date</HeadCell>
              <HeadCell>Actions</HeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
          {user.groups.map((entry, index) => {
            return (
              <TableBodyRow key={entry.id}>
                <DataCell>
                  {(editing && (entry.id === groupID)) ? (
                    <Input          
                      type="text" 
                      autoComplete="name" 
                      value={groupName}
                      onChange={(e) => updateGroupName(e.target.value)}
                    />
                  ) : (
                    entry.name
                  )}
                </DataCell>
                <DataCell number>
                  <Link to={'/dashboard/group/' + entry.id}>{entry.client_count}</Link>
                </DataCell>
                <DataCell number>{moment.utc(entry.created_at).format('MMM D, YYYY')}</DataCell>
                <ButtonCell>
                  <Row>
                    <Action
                      icon={<SearchIcon/>}
                      text="View"
                      onClick={() => props.history.push(`/dashboard/group/${entry.id}`)}
                    />
                    {(editing && (entry.id === groupID)) && 
                      <Action
                        icon={<SaveIcon/>}
                        text="Save"
                        onClick={handleSave}
                      />
                    }
                    <Action
                      icon={<EditIcon/>}
                      text="Edit"
                      onClick={() => handleEditIcon(entry)}
                    />
                    <Action
                      icon={<DeleteIcon />}
                      iconColor='#da0f0f'
                      text="Delete"
                      onClick={() => handleDeleteIcon(entry)}
                    />
                  </Row>
                </ButtonCell>
              </TableBodyRow>
            )
          })}
          </TableBody>
        </Table>
        <Modal
          title={`Delete Group`}
          message={`Are you sure you want to delete this group?`}
          submitLabel="Delete"
          open={showDeleteModal}
          onClose={() => updateShowDeleteModal(false)}
          handleSubmit={handleDelete}
          warning
          disabled={loading}
          isLoading={loading}
        >
          <RemoveText>
            {groupName}
          </RemoveText>
        </Modal>
      </TableContainer>
    </Container>
  )
}

export default GroupsTable